/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Least_Ok_Goldfish_FeelInputs */

const fr_least_ok_goldfish_feel = /** @type {(inputs: Least_Ok_Goldfish_FeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci d'indiquer un email pour inviter un utilisateur`)
};

/**

* @param {Least_Ok_Goldfish_FeelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const least_ok_goldfish_feel = /** @type {((inputs?: Least_Ok_Goldfish_FeelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Least_Ok_Goldfish_FeelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_least_ok_goldfish_feel(inputs)
});